import { createStore } from 'vuex';
import controls from './controls';
export default createStore({
  state: {
    menuType:'',  
    menuClass:"",
  },
  getters: {
    getMenuType(state) {
      return state.menuType;
    },
    getMenuClass(state) {
      return state.menuClass;
    },
  },
  mutations: {
    $changeStore(state: any,payload: any){
      // 判断是否为多层级调用，state中为对象存在的情况，诸如user.info.name = 'xxx'
      const nameArr = payload.name.split('.');
      const len = nameArr.length;
      if (len >= 2){

        let obj = state[nameArr[0]];
        for (let i = 1 ; i < len - 1 ; i++){
          obj = obj[nameArr[i]];
        }
        obj[nameArr[len-1]] = payload.value;
      }else {
        state[payload.name] = payload.value;
      }
    },
    setMenuType(state, payload) {
      state.menuType = payload;
    },
    setMenuClass(state, payload) {
      state.menuClass = payload;
    },
  
  },
  actions:{
    asyncMenuType(store, payload) { 
      store.commit("setMenuType", payload);
    },
    asyncMenuClass(store, payload) { 
      store.commit("setMenuClass", payload);
    },
  
  }
  // modules: {
  //   controls
  // }
});
